import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PaymentForm from './payment-form'
import Subscription from './subscription';


import { isBillingLoading } from 'modules/subscriptions'

class Billing extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
  };

  render() {
    const { isLoading } = this.props;

    if (isLoading !== false) {
      return (<div className="billing-loading">
        <i className="zmdi zmdi-spinner zmdi-hc-spin" />
      </div>)
    }
    return (
      <div>
        <form className="card card-block mb-4">
          <div className="row">
            <label className="col-sm-3 col-form-label mt-3">Payment method</label>
            <div className="col-sm-9">
              <PaymentForm />
            </div>
          </div>
        </form>
        <div className="card card-block">
          <div className="row">
            <label className="col-sm-3 col-form-label">Plan</label>
            <div className="col-sm-9">
              <Subscription />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isLoading: isBillingLoading
});
export default connect(mapStateToProps)(Billing)



// WEBPACK FOOTER //
// ./src/components/account/billing.js